import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = { alignItems: 'center', display: 'flex' };

export const submitButton: SxStyle = {
  fontSize: (p) => p.typography.caption,
  borderRadius: (p) => p.spacing(0.5),
  width: 'max-content',

  '&.Mui-disabled': {
    borderColor: (p) => p.palette.primary[500],
    color: (p) => p.palette.common.white,
    background: (p) => p.palette.primary[500],
    opacity: 0.5,
    cursor: 'none',
  },
};
